import React from "react"
import { Container, Row, Col, Label } from "reactstrap"
import { Form, Input, FormGroup } from "reactstrap"
import stellarProcessing from "../../../view/assets/stellar-animation.gif"
import { Trans, useLingui } from "@lingui/react"
import PropTypes from "prop-types"
import { toast } from "react-toastify"
import { WarningMessage } from "../../../view/shared/notifications/Notifications"
import { connect } from "react-redux"
import validateInput from "../../../view/shared/validations/createLoan"
import { getCurrency } from "../../../view/shared/utilities/currency"
import { initiateTransaction } from "../../../store/reducers/transactions/actions"

import { selectCreatedVslaInfo } from "../../../store/reducers/getVslas"
import { setCurrentPage } from "../../../store/reducers/navigation"
import styles from "./create.module.css"

const notify = (msg) => toast(msg)

const CreateLoan = (props) => {
  const { i18n } = useLingui()

  const [state, setState] = React.useState({
    amount: "",
    service_charge_amount: 0,
    asset: "DEBT",
    source: "member",
    dest: "fund",
    loading: false,
    errors: {},
    lang: i18n.locale,
    loan_purpose: "",
    write_loan_Purpose: false,
    other_purpose_msg: "",
  })

  const onChange = (e) => {
    const { name, value } = e.target
    const write_loan_Purpose = value === "other" || name === "other_purpose_msg"
    const otherPurposeValue = write_loan_Purpose ? state.other_purpose_msg : ""
    setState({
      ...state,
      write_loan_Purpose,
      other_purpose_msg: otherPurposeValue,
      [name]: value,
    })
  }

  const onKeyPress = (e) => {
    const charCode = e.which ? e.which : e.keyCode
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      e.preventDefault()
    }
  }

  const isValid = () => {
    let data = { ...state }
    if (!props.currentMember.loan_service_charge) {
      delete data.service_charge_amount
    }
    const { errors, isValid } = validateInput(data)

    if (!isValid) {
      setState({
        ...state,
        errors,
      })
    }

    return isValid
  }

  const onSubmit = (e) => {
    e.preventDefault()
    if (isValid()) {
      createLoan(
        state.amount,
        state.asset,
        state.source,
        state.dest,
        state.service_charge_amount,
        state.loan_purpose,
        state.other_purpose_msg,
      )
      setState({
        ...state,
        amount: "",
        service_charge_amount: 0,
        other_purpose_msg: "",
        loan_purpose: "",
      })
    }
  }

  const hasLoan = React.useCallback(() => {
    return props.memberDebt(props.currentMember?.pubkey)?.balance > 0
  }, [props.currentMember?.pubkey])

  const isLigibleForLoan = React.useMemo(() => {
    const groupSavings = parseFloat(props.balance?.savings?.balance || 0)
    const memberSavings = props.memberSavings(props.currentMember?.pubkey)?.balance
    const isLessThanGroupSavings = state.amount < groupSavings
    const isLessthanX3ownSavings = memberSavings * 3 > state.amount
    return {
      isEligible:
        parseInt(state.amount) && isLessThanGroupSavings && isLessthanX3ownSavings,
      error: !state.amount
        ? null
        : !isLessThanGroupSavings
          ? "The group does not have sufficient funds"
          : `${props.currentMember?.full_name} does not have enough funds to request for this loan amount`,
    }
  }, [state.amount])

  const createLoan = (
    amount,
    asset,
    source,
    dest,
    service_charge_amount,
    loan_purpose,
    other_purpose_msg,
  ) => {
    const lang_code = i18n.locale

    const lang = {
      fr: {
        message: `Confirmer le prêt de ${parseFloat(state.amount) + parseFloat(state.service_charge_amount)
          } pour le membre`,
      },
      en: {
        message: `Confirm loan of ${parseFloat(state.amount) + parseFloat(state.service_charge_amount)
          } for member`,
      },
      sw: {
        message: `Thibitisha mkopo wa shilingi ${parseFloat(state.amount) + parseFloat(state.service_charge_amount)
          } kwa mwanachama`,
      },
      ZARMA: {
        message: `Zarma for Confirm loan of ${parseFloat(state.amount) + parseFloat(state.service_charge_amount)
          } for member`,
      },
      HAOUSSA: {
        message: `Haoussa for Confirm loan of ${parseFloat(state.amount) + parseFloat(state.service_charge_amount)
          } for member`,
      },
      es: {
        message: `Confirmar préstamo de ${parseFloat(state.amount) + parseFloat(state.service_charge_amount)
          } lempiras para miembro`,
      },
      lb: {
        message: `Confirm loan of ${parseFloat(state.amount)} for household`,
      },
      pt: {
        message: `Confirmar empréstimo de ${parseFloat(state.amount)} para o membro`,
      },
      ar: {
        message: `أكد قرض بقيمة ${parseFloat(state.amount)} للأسرة`,
      },
    }

    if (hasLoan()) {
      notify(<WarningMessage msg={"notifications.loan_error"} />)
      setState({ ...state, loading: false })
      return
    }

    if (window.confirm(lang[lang_code].message)) {
      setState({ ...state, loading: true })

      const uuid = props.currentMember?.pubkey
      const meetingId = props.ongoingMeeting?.id
        ? props.ongoingMeeting?.id
        : props.ongoingMeeting?.cacheId

      if (amount !== "") {
        props.commitTransaction({
          uid: uuid,
          service_charges: parseFloat(service_charge_amount),
          type: "CREATE_LOAN",
          amount: parseFloat(amount),
          sharePrice: 1,
          metadata: {
            loanPurpose: loan_purpose === "other" ? other_purpose_msg : loan_purpose,
          },
          ...(props.currentMember?.id
            ? {
              member_id: props.currentMember?.id,
            }
            : {
              memberCacheId:
                props.currentMember?.cacheId || props.currentMember?.pubkey,
            }),
        })
        notify(<WarningMessage msg={"Processing Transaction"} />)
        props.setPage("group-memberList")
      }
    } else {
      notify(<WarningMessage />)
      setState({ ...state, loading: false })
    }
  }

  // const [totalSHA, setSHA] = React.useState([0])

  // React.useEffect(() => {
  //   let SHA = [0]
  //   props.fund_balance.forEach((f) => {
  //     if (f.asset === "SHAR") {
  //       SHA.push(parseFloat(f.balance))
  //     }
  //   })
  //   setSHA(SHA)
  // }, [])

  // React.useEffect(() => {
  //   let SHA = [0]
  //   props.fund_balance.forEach((f) => {
  //     if (f.asset === "SHAR") {
  //       SHA.push(parseFloat(f.balance))
  //     }
  //   })
  //   setSHA(SHA)
  // }, [props.fund_balance])

  if (!state.loading) {
    return (
      <div>
        <div>
          <h4 className={styles.header}>{props.currentMember?.full_name}</h4>
        </div>
        <div>
          <h4 className={styles.header}>
            <Trans id="Loan">Loan</Trans>
          </h4>
        </div>
        <div className={styles.info}>
          <p>
            <Trans id="Current Savings">Group Savings</Trans>:{" "}
            {parseFloat(props.balance?.savings?.balance || 0).toFixed(2)}{" "}
            {getCurrency(props.group?.country).symbol}
          </p>
          <p>
            <Trans id="Member Savings">Member Savings</Trans>:{" "}
            {parseFloat(
              props.memberSavings(props.currentMember?.pubkey)?.balance || 0,
            ).toFixed(2)}{" "}
            {getCurrency(props.group?.country).symbol}
          </p>
        </div>
        {!isLigibleForLoan?.isEligible && isLigibleForLoan.error ? (
          <span className={styles.errorMessage}>{isLigibleForLoan.error}</span>
        ) : (
          <span></span>
        )}

        <Row>
          <br />
          <Col>
            <Form onSubmit={onSubmit}>
              <Container>
                <FormGroup>
                  <span className={styles.errorMessage}>{state.errors.amount}</span>
                  <Input
                    type="number"
                    name="amount"
                    className={styles.formInput}
                    placeholder={i18n._("Loan Amount")}
                    onChange={onChange}
                    onKeyPress={onKeyPress}
                    value={state.amount}
                  />
                </FormGroup>
                {props.currentMember?.loan_service_charge && (
                  <FormGroup>
                    <span className={styles.errorMessage}>
                      {state.errors.service_charge_amount}
                    </span>
                    <Label className={styles.formLabel}>
                      <span>
                        <Trans id="Loan Service Charge">Loan Service Charge</Trans>
                      </span>
                    </Label>
                    <Input
                      type="number"
                      name="service_charge_amount"
                      className={styles.formInput}
                      placeholder="0"
                      value={state.service_charge_amount}
                      onChange={onChange}
                      onKeyPress={onKeyPress}
                    />
                  </FormGroup>
                )}

                <FormGroup>
                  <span className={styles.errorMessage}>
                    {state.errors.loan_purpose}
                  </span>
                  <Label className={styles.formLabel}>
                    <span>
                      <Trans id="Loan Purpose">Loan Purpose</Trans>
                    </span>
                  </Label>
                  <Input
                    id="loan_purpose"
                    type="select"
                    name="loan_purpose"
                    className={styles.formInput}
                    onChange={onChange}
                    value={state.loan_purpose}
                  >
                    <option value="">{i18n._("Select")}</option>
                    <option value="Business Development">
                      {i18n._("Business Development")}
                    </option>
                    <option value="Personal Emergency">
                      {i18n._("Personal Emergency")}
                    </option>
                    <option value="other">{i18n._("Other")}</option>
                  </Input>
                </FormGroup>

                {state.write_loan_Purpose && (
                  <FormGroup>
                    <span className={styles.errorMessage}>
                      {state.errors.other_purpose_msg}
                    </span>
                    <Label className={styles.formLabel}>
                      <span>
                        <Trans id="Write Loan Purpose">Write Loan Purpose</Trans>
                      </span>
                    </Label>
                    <Input
                      type="text"
                      name="other_purpose_msg"
                      className={styles.formInput}
                      placeholder={i18n._("Loan Purpose")}
                      value={state.other_purpose_msg}
                      onChange={onChange}
                    />
                  </FormGroup>
                )}
              </Container>
              <Container>
                <FormGroup>
                  <Input
                    type="submit"
                    value={i18n._("Submit")}
                    disabled={!isLigibleForLoan.isEligible}
                    name="submit"
                    className={`btn btn-primary ${styles.submitButton}`}
                  />
                </FormGroup>
              </Container>
            </Form>
          </Col>
        </Row>
      </div>
    )
  }

  return (
    <div className={styles.spinnerContainer}>
      <img src={stellarProcessing} className={styles.spinner} alt="Stellar" />
    </div>
  )
}

CreateLoan.propTypes = {
  vsla: PropTypes.object,
  currentMember: PropTypes.object,
  memberDebt: PropTypes.func,
  isLoading: PropTypes.bool,
  balance: PropTypes.object,
  commitTransaction: PropTypes.func,
  ongoingMeeting: PropTypes.array,
  group: PropTypes.object,
  setPage: PropTypes.func,
  fund_balance: PropTypes.array,
}

const mapDispatchToProps = (dispatch) => ({
  setPage: (page) => dispatch(setCurrentPage(page)),
  commitTransaction: (data, meeting) => dispatch(initiateTransaction(data, meeting)),
})

const mapStateToProps = (state) => {
  const { account, accountV2, loadedMember } = state

  // Selector for group-level balances
  const selectBalances = () => {
    if (accountV2.offline) {
      return accountV2.offline.balances
    }
    return account.balances
  }

  // Selector for a specific member's debt, using pubkey as the consistent ID
  const selectMemberDebt = (pubkey) => {
    if (!pubkey) return null

    // Priority 1: Check offline state using pubkey
    if (accountV2.offline?.members[pubkey]) {
      return accountV2.offline.members[pubkey].loan
    }

    if (account.members[pubkey]) {
      return account.members[pubkey].loan
    }

    return null
  }

  // Selector for a specific member's debt, using pubkey as the consistent ID
  const selectMemberSavings = (pubkey) => {
    if (!pubkey) return null

    // Priority 1: Check offline state using pubkey
    if (accountV2.offline?.members[pubkey]) {
      return accountV2.offline.members[pubkey].savings
    }

    if (account.members[pubkey]) {
      return account.members[pubkey].savings
    }

    return null
  }

  return {
    user: state.user,
    fund_balance: state.memberBalanceLoaded,
    isLoading: state.vslaBalanceLoading,
    balance: selectBalances(),
    ongoingMeeting: state.meeting?.ongoing,
    memberDebt: selectMemberDebt,
    memberSavings: selectMemberSavings,
    currentMember: loadedMember,
    group: state.group,
    vslaSummary: selectCreatedVslaInfo(state),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateLoan)
